import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { InitializePayment } = await import('@containers/Payment');
    return {
        Component: InitializePayment,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
